import { Injectable } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";
import { NavigationExtras } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class HelperService {
  constructor() {}

  public static generateQueryParams(queryparams: any = {}) {
    const queryparamsArray = [];
    for (let key in queryparams) {
      if (
        (Array.isArray(queryparams[key]) && !queryparams[key].length) ||
        !queryparams[key]
      ) {
        continue;
      }
      let param =
        key +
        "=" +
        (Array.isArray(queryparams[key])
          ? queryparams[key].join(",")
          : queryparams[key]);
      queryparamsArray.push(param);
    }

    const queryString = queryparamsArray.join("&");

    return queryString;
  }

  // // Turn enum into object
  // public static enumToObject(enumme) {
  //   let enumToObj = {};
  //   Object.keys(enumme).forEach(key => {
  //     if (isNaN(Number(key)) === false) {
  //       enumToObj[key] = enumme[key].split('_').join(' ');
  //     }
  //   });

  //   return enumToObj;
  // }

  // Turn enum into object
  public static enumToObject(enumme: any): any {
    const enumObj = {};
    Object.keys(enumme).forEach((key) => (enumObj[enumme[key]] = key));

    return enumObj;
  }

  public static fillFormValues(values: any, formGroup: FormGroup) {
    Object.keys(values).forEach((key) => {
      formGroup.patchValue({ [key]: values[key] });
    });
  }

  public static fillFilterOption(getFilter: any, myFilter: any) {
    if (!getFilter) return;
    Object.keys(getFilter).forEach((key) => {
      const getFilterObj = getFilter[key];
      Array.isArray(myFilter[getFilterObj.key])
        ? myFilter[getFilterObj.key].push(getFilterObj.value)
        : (myFilter[getFilterObj.key] = getFilterObj.value);
    });
  }

  public static passwordMatchValidator(control: AbstractControl): void {
    const password: string = control.get("password").value; // get password from our password form control
    const confirmPassword: string = control.get("confirm_password").value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get("confirm_password").setErrors({ NoPassswordMatch: true });
    }
  }

  public static onError(option: any, name?:string) {
    const field = name || 'This field'
    const key = Object.keys(option)[0];
    let error = {
      required: "This field is required. Please fill out.",
      "^[0-9]*$": "Field must be number!",
      maxlength: `Maximum ${option[key].requiredLength} letters.`,
      minlength: `${field} needs to have ${option[key].requiredLength} characters or more`,
      email: `Email format is not correct!`,
      UrlFormatIncorrect: "URL format is not correct!",
      NoPassswordMatch: "Password Does not match!",
      "^[A-Za-z-]+$": "Use only latin letters and hyphen",
      "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$":"Email format is not correct!"
    };

    if (key == "pattern") {
      return error[option[key].requiredPattern];
    }

    return error[key];
  }

  public static checkValidation(form: FormGroup, mapping? : any) {
    let errorObj = {};
    Object.keys(form.value).forEach((key) => {
      if (form.controls[key].errors) {
        errorObj[key] = this.onError(form.controls[key].errors);
      }
    });
    return errorObj;
  }

  public static isObjectEmpty(object: any): boolean {
    if (!object) return true;
    return !!(Object.entries(object).length === 0 && object.constructor);
  }

  public static checkEmptyFilter(filter: any): boolean {
    if (!filter) return false;
    let isEmpty = true;
    for (const key of Object.keys(filter)) {
      if (
        (!Array.isArray(filter[key]) && filter[key]) ||
        (Array.isArray(filter[key]) && filter[key].length)
      ) {
        isEmpty = false;
      }
    }
    return isEmpty;
  }

  public static copyImgData(value) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  public static formattedDateFormater(date: any): string {
    if (!date) return null;
    return new Date(date).toISOString().slice(0, 10);
  }

  public static dateFormater(date: any): string {
    if (!date) return null;
    const formatedDate = new Date(date);
    const year = formatedDate.getFullYear(),
      month = formatedDate.getMonth() + 1, // months are zero indexed
      day = formatedDate.getDate(),
      hour = formatedDate.getHours(),
      minute = formatedDate.getMinutes(),
      second = formatedDate.getSeconds();

    return (
      year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
    );
  }

  public static dateFormaterYMD(date: any): string {
    if (!date) return null;
    const formatedDate = new Date(date);
    const year = formatedDate.getFullYear(),
      month = formatedDate.getMonth() + 1, // months are zero indexed
      day = formatedDate.getDate(),
      hour = formatedDate.getHours(),
      minute = formatedDate.getMinutes(),
      second = formatedDate.getSeconds();

    return (
      year + "." + month + "." + day
    );
  }

  public static urlValidator(controlName: string) {
    return (formGroup: FormGroup) => {
      const url = formGroup.value[controlName];
      const pattern = /^https?:\/\/.+\..+$/;

      if (url && !pattern.test(url)) {
        formGroup.get(controlName).setErrors({ UrlFormatIncorrect: true });
      }
    };
  }

  public static getEnumValue(en: any, value: any): string {
    if (!en || this.isObjectEmpty(en) || !value) {
      return "";
    }
    const val = Object.keys(en).find((k) => en[k] === value);
    return val;
  }

  public static goToLink(link: string): void {
    window.open(link, "_blank");
  }

  public static createFormData(files: FileList): FormData {
    const fileToUpload = files.item(0);
    const formData = new FormData();
    formData.append("image", fileToUpload, fileToUpload.name);
    return formData;
  }

  public static removeDups(names) {
    const unique = {};

    names.forEach((i) => {
      if (!unique[i]) {
        unique[i] = true;
      }
    });
    return Object.keys(unique);
  }

  public static strParse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  }

  public static getKeyOf(obj, str) {
    let retkey = null;
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key].toLowerCase() === str.toLowerCase()) {
          retkey = key;
        }
      }
    }

    return retkey;
  }

  // https://gist.github.com/miguelmota/7905510
  public static getDates(startDate, endDate) {
    var dates = [],
      currentDate = startDate,
      addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays.call(currentDate, 1);
    }
    return dates;
  }
}
